//
//
//
//
//
//
//
//
//
//
//
//

import Spin from '../Spin'
import {base, prefix} from '../../common/mixins'

export default {
  name: 'Loading',
  components: {
    Spin,
  },
  mixins: [base, prefix],
  /* eslint-disable vue/require-default-prop */
  props: {
    value: Boolean,
    // 是否不需要包裹层
    noWrap: {
      type: Boolean,
      default: false,
    },
    // spin尺寸
    spinSize: {
      type: String,
      default: '',
    },
    // spin颜色
    spinColor: {
      type: String,
      default: '',
    },
    // SVG图片地址
    svgSrc: {
      type: String,
      default: '',
    },
  },
  /* eslint-enable */
  data () {
    return {
      show: false,
    }
  },
  computed: {
    wrapStyle () {
      return {
        backgroundColor: this.noWrap ? 'transparent' : '',
      }
    },
  },
  watch: {
    value (val) {
      this.show = val
    },
  },
  created () {
    if(this.value) {
      this.show = this.value
    }
  },
}



// WEBPACK FOOTER //
// ./src/components/hippius/components/Dialog/Loading.vue